<div class="middleContent">
    <section class="mt-127px">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-5 pad-right-30 border-right-solid">
                    <div class="row">
                        <div class="col-md-3 align-self-center pe-0">
                            <label style="color: #0070C0;">PROJECT METRICS BY</label>
                        </div>
                        <div class="col-md-3 ps-0">

                            <p-multiSelect [options]="categoryList" [(ngModel)]="selectedCategories" name="category"
                                [showHeader]="true" [filter]="true" placeholder="Select Category"
                                (click)="stopPropagation($event)" (ngModelChange)="selectedCategoryList()">
                                <ng-template pTemplate="header">
                                    <div class="custom-multiselect-header">
                                        <span style="padding-right: 5px;">SELECT ALL</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>

                            <!-- <ng-template #normalDropdown>
                              <select class="form-select border-0" aria-label="Default select example">
                                    <option selected="">Category</option>    
                                    <option *ngFor="let catg of categoryList;" value="catg.value">
                                      <input type="checkbox">{{catg.label}}</option>
                              </select>
                          </ng-template>  -->
                        </div>
                        <div class="col-md-3 pe-0 mt-1">
                            <!-- <input type="Date" class="form-control border-0"> -->

                            <p-calendar dateFormat="dd-M-yy"
                                [style]="{'width':'100%','margin-top':'-3px','height':'32px !important'}"
                                [(ngModel)]="selectedDateRange" (click)="stopPropagation($event)"
                                (ngModelChange)="selectedSubmittedDateRange()" selectionMode="range">
                            </p-calendar>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-md-4 pad-right-30 text-end align-self-center">
                            <div class="float-end">
                                <div class="d-flex mb-5">
                                    <div class="align-self-center me-3 w-75">
                                        <label for="">PROJECTS</label>
                                    </div>
                                    <div>
                                        <h6 class="countBox projectsBg mb-0">{{projectsCount}}</h6>
                                    </div>
                                </div>



                                <div class="d-flex">
                                    <div class="align-self-center me-3 w-75">
                                        <label for="">SALES PLAN </label>
                                    </div>
                                    <div>
                                        <h6 class="countBox salesPlanBg mb-0">{{salesPlanCount}}</h6>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div class="col-md-8 border-left-solid pb-50 ps-30">
                            <h6 class="headingTextt text-center mb-3 mt-0 graphTitle">ACTIVE PROJECTS / SALES PLAN</h6>
                            <!-- <img src="assets/images/graph.png" class="graphBgSec" alt=""> -->
                            <div id="projectStatusChartcontainer"></div>
                        </div>
                    </div>

                    <div class="row border-top">
                        <div class="col-md-4 pad-right-30 text-end align-self-center">
                            <div class="float-end justify-content-end">
                                <div class="d-flex mb-5">
                                    <div class="align-self-center me-3 w-75">
                                        <label for="">STORES</label>
                                    </div>
                                    <div>
                                        <h6 class="countBox projectsBg mb-0">{{storesCount}}</h6>
                                    </div>
                                </div>



                                <div class="d-flex">
                                    <div class="align-self-center me-3 w-75">
                                        <label for="">AGENCIES</label>
                                    </div>
                                    <div>
                                        <h6 class="countBox salesPlanBg mb-0">{{agencyCount}}</h6>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div class="col-md-8  border-left-solid pt-2 ps-30">
                            <h6 class="headingTextt text-center mb-3 mt-3 graphTitle">ONGOING EXECUTION(PROJECTS)</h6>
                            <!-- <img src="assets/images/ongoingChart.png" class="graphBgSec pb-0 pt-2" alt=""> -->
                            <div id="onGoingExecutionChartcontainer" class="chartMargin"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="row tiles">
                        <div class="col-4">
                            <div class="section">
                                <div class="section-header">PROJECTS</div>
                                <div class="section-body">
                                    <a href="#projectintake/addproject" class="button"><img
                                            src="assets/images/newprojectblue.svg" class="dashboardIcon" alt=""> SETUP
                                        PROJECT</a>
                                    <a href="/#/manage-projects" class="button"><img
                                            src="assets/images/manageprojectsblue.svg" class="dashboardIcon" alt="">
                                        MANAGE PROJECT</a>
                                    <a href="#verification/Dashboard" class="button"><img
                                            src="assets/images/verificationblue.svg" class="dashboardIcon" alt="">
                                        VERIFICATION</a>
                                </div>
                                <a href="/#/reports/dashboard" class="button reports"><img
                                        src="assets/images/reportswhite.svg" class="dashboardIcon" alt=""> REPORTS</a>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="section">
                                <div class="section-header">SALES PLAN</div>
                                <div class="section-body">
                                    <a href="/#/addsalesplan" class="button"><img src="assets/images/saleplanblue.svg"
                                            class="dashboardIcon" alt=""> SETUP SALES PLAN</a>
                                    <a href="/#/manage-salesplan" class="button"><img
                                            src="assets/images/managesalesplanblue.svg" class="dashboardIcon" alt="">
                                        MANAGE SALES PLAN</a>

                                </div>
                                <a href="/#/usermanagement/systemadmin" class="button reports"><img
                                        src="assets/images/system.svg" class="dashboardIcon" alt=""> SYSTEM
                                    ADMIN</a>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="section">
                                <div class="section-header">COVERAGE PRIORITIES</div>
                                <div class="section-body">
                                    <a href="/#/adhoc/add" class="button"><img src="assets/images/setupadhocblue.svg"
                                            class="dashboardIcon" alt=""> SETUP AD HOC
                                        PRIORITIES</a>
                                    <a href="/#/add-adhoc-list" class="button"><img
                                            src="assets/images/manageadhocblue.svg" class="dashboardIcon" alt=""> MANAGE
                                        AD HOC
                                        PRIORITIES</a>
                                    <a href="/#/storecoverage-list" class="button"><img
                                            src="assets/images/manageStore_blu.png" class="dashboardIcon" alt="">
                                        MANAGE STORE COVERAGE</a>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</div>